<div class="event-cards" *ngIf="eventCards">
    <div class="event-cards__container" [ngStyle]="{ 'margin-left.px': eventCards.length > 1 ? 16 : 0 }">
        <app-menu-event-card
            *ngFor="let card of eventCards"
            [card]="card"
            [width]="width"
            [height]="height">
        </app-menu-event-card>
    </div>
</div>
